import { leadActionTypes } from "./actionTypes";
import { IConfirmation } from "../../Models/Confirmation";
import { IPersonalData } from "../../Models/PersonalData";
import { IElec } from "../../Models/Elec";
import { IGas } from "../../Models/Gas";
import { IBillingAddress } from "../../Models/BillingAddress";
import { IBilling } from "../../Models/Billing";
import { ISelectedProduct } from "../../Models/Simulation";
import { ILead } from "../../Models/Lead";
import { ActionPayload } from "../stateAction";

export const setDynamicParams = (
	userDetails: any,
	selectedProducts: ISelectedProduct
) => ({
	type: leadActionTypes.SET_DYNAMIC_PARAMS,
	payload: { userDetails, selectedProducts }
});

export const setSavedSimuParams = (
	values: any,
	selectedProducts: ISelectedProduct
) => ({
	type: leadActionTypes.SET_SAVED_SIMU_PARAMS,
	payload: { values, selectedProducts }
});

export const updateSimuParams = (
	selectedProducts: any
) => ({
	type: leadActionTypes.UPDATE_SIMU_FLAGS,
	payload: selectedProducts
});

export const savePromoCode = (promoCode: string) => ({
	type: leadActionTypes.SET_PROMO_CODE,
	payload: promoCode
});

export const saveRefCustomerId = (refCustomerId: string) => ({
	type: leadActionTypes.SET_REF_ID,
	payload: refCustomerId
});

export const saveUserData = (userData: any) => ({
	type: leadActionTypes.SET_USER_DATA,
	payload: userData
});

export const saveFinancialData = (financialData: any) => ({
	type: leadActionTypes.SET_FINANCIAL_DATA,
	payload: financialData
});

export const updatePersonnalData = (personnalData: IPersonalData) => ({
	type: leadActionTypes.UPDATE_PERSONNAL_DATA,
	payload: personnalData
});

export const updateElecData = (elecData: IElec) => ({
	type: leadActionTypes.UPDATE_ELEC_DATA,
	payload: elecData
});

export const updateGasData = (gasData: IGas) => ({
	type: leadActionTypes.UPDATE_GAS_DATA,
	payload: gasData
});

export const updateBillingAddr = (billingAddr: IBillingAddress) => ({
	type: leadActionTypes.UPDATE_BILLING_ADDR,
	payload: billingAddr
});

export const updateBillingData = (billingData: IBilling) => ({
	type: leadActionTypes.UPDATE_BILLING_DATA,
	payload: billingData
});

export const validateSignUp = (
	confirmationData: IConfirmation
) => ({
	type: leadActionTypes.VALIDATE_SIGN_UP,
	payload: { confirmationData }
});

export const initLead = (lead: any) => ({
	type: leadActionTypes.INIT_LEAD,
	payload: lead
});

